import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  mutations: {},
  actions: {}
};

appStore.registerModule('Focus', store);
